export const error = (state) => state.error;
export const isLoading = (state) => state.isLoading;
export const updated = (state) => state.updated;
